/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as m } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import { Form as t } from "@nubeteck/components";
const e = ({ children: r, ...o }) => /* @__PURE__ */ m.jsx(t, { ...o, children: r });
export {
  e as default
};
